import type { ViewerModel } from '@wix/thunderbolt-symbols'

const EDITOR_REACT_COMPONENTS_EXTERNAL_ID = 'editor-react-components'
const EDITOR_SYSTEM_COMPONENTS_EXTERNAL_ID = 'editor-system-components'

export function getComponentsExternalVersions(viewerModel: ViewerModel): Record<string, string> {
	const versions = viewerModel?.componentsExternalVersions ?? {}
	const editorReactComponentsVersion = versions[EDITOR_REACT_COMPONENTS_EXTERNAL_ID]
	const editorSystemComponentsVersion = versions[EDITOR_SYSTEM_COMPONENTS_EXTERNAL_ID]

	return {
		...(editorReactComponentsVersion ? { editorReactComponentsVersion } : {}),
		...(editorSystemComponentsVersion ? { editorSystemComponentsVersion } : {}),
	}
}
